import React from 'react';
import { Settings } from 'lucide-react';

/**
 * Секция с дополнительными параметрами
 */
const AdvancedOptionsSection = ({ formData, handleInputChange, errors }) => {
  // Если нет никаких дополнительных параметров, можно скрыть раздел
  const hasAdvancedOptions = formData.includeGoogleAnalytics || 
                              formData.useUtmParameters || 
                              formData.addSignature;
  
  return (
    <div className="mb-3">
      <button
        type="button"
        onClick={() => document.getElementById('advancedOptions').classList.toggle('hidden')}
        className="flex items-center text-sm font-medium text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 mb-2"
      >
        <Settings className="w-4 h-4 mr-2" />
        Дополнительные параметры {hasAdvancedOptions && '(активны)'}
      </button>
      
      <div id="advancedOptions" className="hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-200 dark:border-gray-700">
          {/* UTM параметры */}
          <div>
            <label className="flex items-center mb-2">
              <input
                type="checkbox"
                name="useUtmParameters"
                checked={formData.useUtmParameters}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                Добавить UTM-метки для отслеживания
              </span>
            </label>
            
            {formData.useUtmParameters && (
              <div className="pl-6 space-y-3 mt-2">
                <div>
                  <label htmlFor="utmSource" className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Источник (utm_source)
                  </label>
                  <input
                    type="text"
                    id="utmSource"
                    name="utmSource"
                    value={formData.utmSource}
                    onChange={handleInputChange}
                    placeholder="email"
                    className="form-input text-sm py-1.5"
                  />
                </div>
                
                <div>
                  <label htmlFor="utmMedium" className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Тип трафика (utm_medium)
                  </label>
                  <input
                    type="text"
                    id="utmMedium"
                    name="utmMedium"
                    value={formData.utmMedium}
                    onChange={handleInputChange}
                    placeholder="mailto"
                    className="form-input text-sm py-1.5"
                  />
                </div>
                
                <div>
                  <label htmlFor="utmCampaign" className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Название кампании (utm_campaign)
                  </label>
                  <input
                    type="text"
                    id="utmCampaign"
                    name="utmCampaign"
                    value={formData.utmCampaign}
                    onChange={handleInputChange}
                    placeholder="spring_sale"
                    className={`form-input text-sm py-1.5 ${errors.utmCampaign ? 'input-error' : ''}`}
                  />
                  {errors.utmCampaign && (
                    <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                      {errors.utmCampaign}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
          
          {/* Google Analytics */}
          <div>
            <label className="flex items-center mb-2">
              <input
                type="checkbox"
                name="includeGoogleAnalytics"
                checked={formData.includeGoogleAnalytics}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                Отслеживание через Google Analytics
              </span>
            </label>
            
            {formData.includeGoogleAnalytics && (
              <div className="pl-6 space-y-3 mt-2">
                <div>
                  <label htmlFor="gaTrackingId" className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Tracking ID (UA-XXXXXXXX-X или G-XXXXXXXXXX)
                  </label>
                  <input
                    type="text"
                    id="gaTrackingId"
                    name="gaTrackingId"
                    value={formData.gaTrackingId}
                    onChange={handleInputChange}
                    placeholder="UA-XXXXXXXX-X"
                    className={`form-input text-sm py-1.5 ${errors.gaTrackingId ? 'input-error' : ''}`}
                  />
                  {errors.gaTrackingId && (
                    <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                      {errors.gaTrackingId}
                    </p>
                  )}
                </div>
                
                <div className="pt-1">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="trackOpens"
                      checked={formData.trackOpens}
                      onChange={handleInputChange}
                      disabled={!formData.includeGoogleAnalytics}
                      className="form-checkbox"
                    />
                    <span className="ml-2 text-xs text-gray-700 dark:text-gray-300">
                      Отслеживать открытия письма (добавить пиксель)
                    </span>
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedOptionsSection;